import React from 'react';

import PropTypes from 'prop-types';

import {
  BlockContainer,
  BlockItemContainer,
  BlockItemHead,
  BlockTitle,
  Email,
  RoleLabel
} from '../css';
import { CONSTANT } from '../../utils/constant';

import Actions from './actions';
import PendingApproval from './pendingApproval';
import UserDisabled from './userDisabled';
import UserDeleted from './userDeleted';

const UserBlock = ({ users, fetchUsers }) => {
  const {
    KEYS: {
      USER_STATUS: { PENDING_APPROVAL, APPROVED }
    }
  } = CONSTANT;

  return (
    <BlockContainer>
      {users &&
        users.map(user => {
          const {
            id,
            first_name: firstName,
            last_name: lastName,
            email,
            status,
            isDisabled,
            is_deleted: isDeleted
          } = user;
          const userDisabled = isDisabled === 1;
          const username = `${firstName} ${lastName}`;
          const greyOut =
            status === PENDING_APPROVAL || userDisabled || isDeleted;

          return (
            <BlockItemContainer
              isDeleted={isDeleted}
              isDisabled={userDisabled}
              isApproved={status === APPROVED}
            >
              <BlockItemHead greyOut={greyOut}>
                <BlockTitle isDisabled={greyOut}>{username}</BlockTitle>
                <Email isDisabled={greyOut}>{email}</Email>
              </BlockItemHead>
              {status === PENDING_APPROVAL && !isDeleted && (
                <PendingApproval userId={id} fetchUsers={fetchUsers} />
              )}
              {userDisabled && (
                <UserDisabled email={email} fetchUsers={fetchUsers} />
              )}
              {isDeleted && <UserDeleted userId={id} fetchUsers={fetchUsers} />}
              {status === APPROVED && !userDisabled && !isDeleted && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '1rem',
                      alignItems: 'center'
                    }}
                  >
                    <RoleLabel>{user.role.description}</RoleLabel>
                    <Actions userData={user} fetchUsers={fetchUsers} />
                  </div>
                </div>
              )}
            </BlockItemContainer>
          );
        })}
    </BlockContainer>
  );
};

UserBlock.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fetchUsers: PropTypes.func.isRequired
};

export default UserBlock;
